import IframeActivity from "./IframeActivity";

export default function Bookmaker() {
    return (
        <IframeActivity
            src="/activities/bookmaker/index.html"
            title="Bookmaker"
        />
    );
}